import React from 'react';
import { Route } from 'react-router';

import {
    PasswordResetLinkExpirationPage
} from "../../components/Pages/PasswordResetLinkExpiration/PasswordResetLinkExpirationPage";

const routes = <Route path="passwordresetlinkexpiration" component={PasswordResetLinkExpirationPage} />;

export default  routes;


// WEBPACK FOOTER //
// ./src/routes/www/passwordresetlinkexpiration.js